import {
  type FeatureFlag,
  useFlags,
} from '@terminal/stores/use-flags/useFlags';

export const API_V3_PRICES_FEATURE_FLAG: FeatureFlag =
  'DATA_1489_api_v3_prices';

export const isApiV3PricesEnabled = () =>
  useFlags.getState().getFeatureFlagState(API_V3_PRICES_FEATURE_FLAG);
